module.exports = __webpack_public_path__ + "officialStatic/img/map-icon.df65506.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/map-icon.png
// module id = MQEk
// module chunks = 0